import * as React from "react";

import { resolveColor } from "utils/commonFunctions";

interface Props {
    color?: string;
    detailColor?: string;
    size?: number;
}

const toColor = (value: string): string => (value.startsWith("--") ? resolveColor(value) : value);

export const Failure = (props: Props) => {
    const size = props.size ?? 24;
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                fill={toColor(props.color ?? "--theme-icon-fill-error")}
            />
            <path
                d="M8.5 8.5L15.5 15.5M15.5 8.5L8.5 15.5"
                stroke={toColor(props.detailColor ?? "--theme-icon-fill-detail")}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};
